// extracted by mini-css-extract-plugin
export default {"button":"feedback_box_button-module__button--AfXWA"};